import Vue from 'vue'
import App from './App.vue'

// 关闭提示信息
Vue.config.productionTip = false; // 关闭生产提示
Vue.config.devtools = false; // 关闭开发工具
Vue.config.silent = true; // 关闭所有警告
// 自定义挂载函数
import globalFunctions from './tool/utils';
Vue.prototype.$tool = globalFunctions
// VUEX
import store from './store'
// 路由
import router from './router'
// 适配不同屏幕
import '@/tool/rem'
// element
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
Vue.use(ElementUI);
// Avue
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
Vue.use(Avue);

Vue.config.productionTip = false

new Vue({
	store,
	router,
	render: h => h(App)
}).$mount('#app')